import { Skeleton, Stack, ToggleButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import StyledToggleButtonGroup from '../eir-mobile-offer-toggle/MobileOfferToggle.styled';
import styles from './styles';

const HandsetStorageSelector = ({ storages, loadingHandset, selected, selectVariant }) => {
  const [storageSelector, setStorageSelector] = useState();
  const theme = useTheme();
  const handleStorageChange = (event, value) => {
    if (value !== null) selectVariant('storage', value);
    setStorageSelector(value);
  };
  useEffect(() => {
    setStorageSelector(selected.storage);
  }, [selected.storage, storageSelector]);
  return !loadingHandset ? (
    <Stack>
      <Typography variant='body1' sx={styles(theme).colorTitle}>
        Storage:
        <Typography variant='body1' sx={styles(theme).storageValue}>
          &nbsp; {storageSelector}
        </Typography>
      </Typography>
      <Stack direction='row'>
        <StyledToggleButtonGroup
          size='small'
          selected
          exclusive
          value={selected.storage}
          onChange={handleStorageChange}
          aria-label='storage'
          sx={styles(theme).storageSelector}
          standaloneHandset
        >
          {storages?.map((storage, index) => (
            <ToggleButton
              key={index}
              value={storage.value}
              sx={styles(theme).storageButton}
              height={40}
              disabled={storage.disable}
            >
              {storage.disable ? storage.value : <Typography>{storage.value}</Typography>}
            </ToggleButton>
          ))}
        </StyledToggleButtonGroup>
      </Stack>
    </Stack>
  ) : (
    <Stack>
      <Skeleton variant='text' width='30%' />
      <Stack direction='row'>
        {Array(3)
          .fill()
          .map((_, i) => (
            <Skeleton key={i} sx={{ flex: 0.2, mr: 2 }} height={40} />
          ))}
      </Stack>
    </Stack>
  );
};

export default HandsetStorageSelector;
